// Single source of truth for business details. Used by the UI, the SEO tags and JSON-LD.
export const SITE = {
  name: 'Green Valley Interiors',
  shortName: 'Green Valley',
  tagline: 'Inspiring spaces, inspired living',
  origin: 'https://www.greenvalleyinterior.com',
  locale: 'en_IN',
  phoneDisplay: '+91 822 006 0017',
  phoneE164: '+918220060017',
  whatsappUrl: 'https://wa.me/918220060017',
  email: 'contact@greenvalleyinterior.com',
  address: {
    line1: 'Praise Complex, 2nd Floor',
    line2: 'Asaripallam Road',
    locality: 'Nagercoil',
    region: 'Tamil Nadu',
    postalCode: '629201',
    country: 'IN',
    countryName: 'India',
  },
  geo: { lat: 8.1833, lng: 77.4119 },
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Praise+Complex+Asaripallam+Road+Nagercoil',
  mapsEmbedUrl: 'https://www.google.com/maps?q=Praise+Complex,+Asaripallam+Road,+Nagercoil,+Tamil+Nadu&output=embed',
  hours: { display: 'Monday – Saturday · 9:00 AM – 7:30 PM IST', opens: '09:00', closes: '19:30' },
  areaServed: ['Nagercoil', 'Kanyakumari', 'Trivandrum', 'Tirunelveli', 'Madurai', 'Kochi'],
  // Add real profile URLs here; empty entries are not rendered and not added to JSON-LD.
  social: {
    instagram: '',
    facebook: '',
    youtube: '',
  },
  defaultOgImage: '/brand/og-default.jpg',
} as const;

export const absoluteUrl = (path: string) => (path === '/' ? `${SITE.origin}/` : `${SITE.origin}${path}`);

export const fullAddress = `${SITE.address.line1}, ${SITE.address.line2}, ${SITE.address.locality}, ${SITE.address.region} ${SITE.address.postalCode}, ${SITE.address.countryName}`;
